import {Navigate, Route} from "react-router-dom";
import {permitApplicationRoutes} from "permitapplication/module";
import {permitExtensionRoutes} from "permitextension/module";
import {approvedPermitRoutes} from ".";

const permitRoutes = [
    permitApplicationRoutes,
    approvedPermitRoutes,
    permitExtensionRoutes,
    <Route
        key="redirect-permit-index"
        index
        element={<Navigate to="list" replace />}
    />,
];

export default permitRoutes;
